import { Component, Input, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { Search } from '../core/models/search.model';
import { SearchService } from '../core/services/search.service';
import { NgSelectComponent } from "@ng-select/ng-select";

@Component({
  selector: 'app-search',
  templateUrl: './search.component.html',
  styleUrls: ['./search.component.css']
})
export class SearchComponent {

  loading: boolean = false;
  searchResults: Search[];
  timeout: ReturnType<typeof setTimeout>;

  @Input() locale: string;

  @ViewChild(NgSelectComponent) ngSelectComponent: NgSelectComponent;

  constructor(private router: Router, private service: SearchService) { }

  onSearch(term: string) {
    if (term.length > 1) {
      clearTimeout(this.timeout);
      this.loading = true;
      this.timeout = setTimeout(() => {
        this.load(term)
      }, 1000);
    }
  }

  onChange(selected: any) {
    if (selected) {
      this.ngSelectComponent.handleClearClick();
      this.router.navigate(['/dashboard'], { queryParams: { cpa: selected.CPA_KEY }, queryParamsHandling: 'merge' });
    }
  }

  private load(term: string) {
    this.service.get(term.toUpperCase()).subscribe((searchResults: Search[]) => {
      this.searchResults = searchResults;
      this.loading = false;
    });
  }

  searchFn(): boolean {
    return true;
  }

}
